import React from "react";
import styles from "./button.module.scss";

import { NotifyMessage } from "contexts/notifyToast";
import { Notify } from "./Notify";
interface NotificationProps {
    messageNotify: NotifyMessage[]
}

export const ToastNotify: React.FC<NotificationProps> = ({
    messageNotify
}) => {

    return (
        <div className={styles.container}>
            {messageNotify.map((message) => (
                <Notify key={message.id} data={message} />
            ))}
        </div>
    );
};
